import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import useMobileLayout from 'Hooks/useMobileLayout';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import Content from 'Views/Page/Content/Templates/WizardTemplates/CIPFinishTemplate/Content';
import WizardCompleteStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardCompleteStepTemplate';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import history from 'State/history';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  desktopMargin: {
    marginLeft: theme.spacing(10),
  },
  form: {
    maxWidth: '100%',
  },
});
const CIPFinishTemplate = ({
  className,
  classes,
  resource,
}) => {
  const { loadHousehold: refreshHousehold } = useSimpleHousehold();
  const isMobile = useMobileLayout();

  useComponentDidMount(async () => {
    await refreshHousehold();
  });

  const {
    loadPageContentLink,
  } = usePageContentContext();

  async function handleFooterActionClick() {
    if (resource.relationship(fr.relationships.specificPageLink.name)?.meta('type') === 'step') {
      loadPageContentLink(resource.relationship(fr.relationships.specificPageLink.name).link('related'));
    } else {
      history.push('/');
    }
  }


  return (
    <WizardCompleteStepTemplate
      className={classNames(className, classes.root, { [classes.navMargin]: !isMobile })}
      content={Content}
      resource={resource}
      metaOverrideSet={BaseOverride}
      onNext={handleFooterActionClick}
    />
  );
};

CIPFinishTemplate.defaultProps = {
  className: '',
};

CIPFinishTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(CIPFinishTemplate);
